var React = require('react');
var css = require('./module.scss');
var CheckBox = require('../checkbox');

var Radio = React.createClass({
    getInitialState: function() {
        return {
            value: this.props.value
        };
    },

    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value
        });
    },

    onChange: function(value) {
        this.setState({
            value: value
        });
        this.props.onChange && this.props.onChange(value);
    },

    render: function() {
        var opts = this.props.options;
        var disabled = this.props.disabled;
        var me = this;
        return <div className={this.props.className || ''}>
            {
                opts.map(function(item, index) {
                    return <CheckBox title={item.name}
                        checked={me.props.value === item.value}
                        onChange={me.onChange.bind(me, item.value)}
                        disabled={disabled}
                        type="radio"
                        key={item.name}/>;
                })
            }
        </div>;
    }
});

module.exports = Radio;



// WEBPACK FOOTER //
// ./component/radio/radio.js